import { faCircleNotch, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ErrorMessage from "components/reusable/ErrorMessage";
import Toolbar from "components/Toolbar";
import AuthContext from "context/AuthContext";
import useToastContext from "hooks/useToastContext";
import { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { apiPost } from "utils/apiFetch";
import pathObj from "utils/apiPath";
import { validationRules } from "utils/constants";

function ResetPassword() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const notification = useToastContext();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onChange", shouldFocusError: true, defaultValues: {} });

  const [loading, setLoading] = useState(false);

  const [icon1, setIcon1] = useState(true);
  const [icon2, setIcon2] = useState(true);
  const [icon3, setIcon3] = useState(true);
  const [confirmPasswordError, setConfirmPasswordError] = useState(false);

  const { logoutUser } = useContext(AuthContext);

  const [showOtpDialog, setShowOtpDialog] = useState(false);

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      if (data.new_password !== data.confirm_new_password) {
        setLoading(false);
        setConfirmPasswordError(true);
        return;
      }

      const requestBody = {
        oldPassword: data.current_password,
        newPassword: data.new_password,
      };
      const res = await apiPost(pathObj.changePassword, requestBody);
      if (res.data.success) {
        notification.success(res.data.message);
        logoutUser();
      } else {
        notification.error(res.data.message);
      }
    } catch (err) {}
    setLoading(false);
  };

  return (
    <>
      <Toolbar title={t("SETTINGS_CHANGE_PASSWORD")} showBackBtn={true} />
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col w-full justify-center items-center">
        <div className="mt-3 p-4 rounded-3xl h-full w-full md:w-[25rem]">
          <div className="mt-2 mx-2">
            <div className="mb-5 relative">
              <input
                type={icon1 ? "password" : "text"}
                id="current_password"
                className="inputform text-heading text-sm rounded-base block w-full px-3 py-2.5 shadow-xs placeholder:text-body"
                placeholder={t("SETTINGS_CURRENT_PASSWORD")}
                onKeyDown={(e) => {
                  e.target.value = e.target.value.trim();
                }}
                {...register("current_password", {
                  required: t("REGISTER_PASSWORD"),
                  pattern: {
                    value: validationRules.password,
                    message: validationRules.passwordMessage,
                  },
                })}
                required
              />
              {icon1 ? (
                <span className="password_view cursor-pointer absolute top-[0.8rem] right-[1rem]" onClick={() => setIcon1(!icon1)}>
                  <FontAwesomeIcon icon={faEye} />
                </span>
              ) : (
                <span className="password_view cursor-pointer absolute top-[0.8rem] right-[1rem]" onClick={() => setIcon1(!icon1)}>
                  <FontAwesomeIcon icon={faEyeSlash} />
                </span>
              )}
              <ErrorMessage message={errors?.current_password?.message} />
            </div>

            <div className="mb-5 relative">
              <input
                type={icon2 ? "password" : "text"}
                id="new_password"
                className="inputform text-heading text-sm rounded-base block w-full px-3 py-2.5 shadow-xs placeholder:text-body"
                placeholder={t("O_NEW_PASSWORD")}
                onKeyDown={(e) => {
                  e.target.value = e.target.value.trim();
                }}
                {...register("new_password", {
                  required: t("REGISTER_PASSWORD"),
                  pattern: {
                    value: validationRules.password,
                    message: validationRules.passwordMessage,
                  },
                })}
                required
              />
              {icon2 ? (
                <span className="password_view cursor-pointer absolute top-[0.8rem] right-[1rem]" onClick={() => setIcon2(!icon2)}>
                  <FontAwesomeIcon icon={faEye} />
                </span>
              ) : (
                <span className="password_view cursor-pointer absolute top-[0.8rem] right-[1rem]" onClick={() => setIcon2(!icon2)}>
                  <FontAwesomeIcon icon={faEyeSlash} />
                </span>
              )}
              <ErrorMessage message={errors?.new_password?.message} />
            </div>

            <div className="mb-5 relative">
              <input
                type={icon3 ? "password" : "text"}
                id="confirm_new_password"
                className="inputform text-heading text-sm rounded-base block w-full px-3 py-2.5 shadow-xs placeholder:text-body"
                placeholder={t("SETTINGS_CONFIRM_NEW_PASSWORD")}
                onKeyDown={(e) => {
                  e.target.value = e.target.value.trim();
                }}
                {...register("confirm_new_password", {
                  required: t("REGISTER_PASSWORD"),
                  pattern: {
                    value: validationRules.password,
                    message: validationRules.passwordMessage,
                  },
                })}
                required
              />
              {icon3 ? (
                <span className="password_view cursor-pointer absolute top-[0.8rem] right-[1rem]" onClick={() => setIcon3(!icon3)}>
                  <FontAwesomeIcon icon={faEye} />
                </span>
              ) : (
                <span className="password_view cursor-pointer absolute top-[0.8rem] right-[1rem]" onClick={() => setIcon3(!icon3)}>
                  <FontAwesomeIcon icon={faEyeSlash} />
                </span>
              )}
              <ErrorMessage message={errors?.confirm_new_password?.message} />
              {confirmPasswordError && <ErrorMessage message={t("REGISTER_PASS_CONFIRM_PASS")} />}
            </div>

            <div className="w-full mt-5">
              {loading ? (
                <div className="btn btn_theme w-full flex items-center justify-center p-3">
                  <FontAwesomeIcon icon={faCircleNotch} className="text-white text-xl animate-spin" />
                </div>
              ) : (
                <button className="btn btn_theme w-full text-white" type="submit">
                  {t("CONTINUE")}
                </button>
              )}
            </div>
          </div>
        </div>
      </form>
    </>
  );
}

export default ResetPassword;
